const page_mid_one_array = [
    {
        id: 1,
        alt: "Sobre o treino.",
        imgURL: "images/equipamento.jpeg",
        imgURL2: "images/treino-focado.jpg",
        text: "Variedade de Equipamentos",
        text2: "Dispomos de grande variedade de equipamentos para te ajudar a atingir seus objetivos!",
        text3: "Foco em Resultados",
        text4: "Vamos criar um treino personalizado para que você alcance suas necessidades e metas da melhor maneira!"
    },
];

export default page_mid_one_array;